import { render, staticRenderFns } from "./SliceText.vue?vue&type=template&id=3134a1fb&scoped=true&"
import script from "./SliceText.vue?vue&type=script&lang=js&"
export * from "./SliceText.vue?vue&type=script&lang=js&"
import style0 from "./SliceText.vue?vue&type=style&index=0&id=3134a1fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3134a1fb",
  null
  
)

export default component.exports